module.exports = __webpack_public_path__ + "public/img/02.5401d295.jpg";